import React, { useEffect } from 'react';
import { useAppSelector } from 'store/hooks';
import { AppView, withAnimatedNavigationHeader } from 'design-system';
import { navigateToTab } from 'hooks/navigation/useTabNavigation';
import Pots from '../components/Pots';
import { selectShouldShowPotsList } from '../reducers/selectors';
const PotListScreen = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    const shouldShowPotsList = useAppSelector(selectShouldShowPotsList);
    const potsAccountStatus = useAppSelector((state) => state.pots.account?.status);
    useEffect(() => {
        if (!shouldShowPotsList) {
            if (potsAccountStatus === 'NOT_STARTED') {
                navigateToTab('Save', { tab: 'pots' });
            }
            else {
                navigation.goBack();
            }
        }
    }, [navigation, potsAccountStatus, shouldShowPotsList]);
    if (!shouldShowPotsList) {
        return null;
    }
    return (<AppView withFrame={false}>
        <Pots onScroll={scrollHandler}/>
      </AppView>);
}, ({ colors }) => ({
    title: 'Save',
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
export default PotListScreen;
